import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import Button from '@mui/material/Button'
import DisclaimerImage from 'src/assets/Buy_Policy_Images/Disclaimer.svg'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'

const Disclaimer = ({ closeDisclaimer, handleClose }) => {
  const classes = useStyles()

  const handleNext = () => {
    closeDisclaimer()
  }

  return (
    <div className={classes.mainContainer}>
      <div className={classes.closeButton}>
        <IconButton onClick={() => handleClose()} id='IconButton'>
          <CloseIcon />
        </IconButton>
      </div>
      <div className={classes.mainContent}>
        <div>
          <img
            src={DisclaimerImage}
            alt='desclaimerImage'
            className={classes.desclaimerImage}
          />
        </div>
        <div className={classes.headingContainer}>
          <div>
            <span className={classes.heading}>You can say NO!</span>
          </div>
          <div className={classes.subHeadingContent}>
            <span className={classes.subHeading}>
              You have the right to say{' '}
              <span className={classes.subText}>NO</span> for insurance from
              your dealer & purchase it elsewhere.{' '}
              <span className={classes.subText}>It&apos;s not mandatory</span>.
            </span>
          </div>
          <div className={classes.descriptionContent}>
            <span className={classes.description}>
              Get an assured discount compared to showroom prices. Inquire now
              and see for yourself!
            </span>
          </div>
          <div>
            <Button
              variant='contained'
              onClick={handleNext}
              className={classes.nextButton}
            >
              Next
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Disclaimer
const useStyles = makeStyles({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    background:
      'linear-gradient(192.92deg, #4DC3E3 -250.34%, rgba(255, 255, 255, 0) 50.64%)',
  },
  mainContent: {
    display: 'flex',
    padding: '30px 80px 60px 80px',
    gap: '25px',
  },
  heading: {
    fontFamily: 'Roboto',
    fontSize: '28px',
    fontWeight: '700',
    color: '#000000',
  },
  headingContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  subHeading: {
    fontFamily: 'Roboto',
    fontSize: '19px',
    fontWeight: '400',
    color: '#000000',
    // lineHeight:'26.95px',
  },
  subText: {
    fontFamily: 'Roboto',
    fontSize: '23px',
    fontWeight: '700',
    color: '#000000',
    // lineHeight:'26.95px',
  },
  description: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: '400',
    color: '#000000',
    // lineHeight:'22.27px',
  },
  subHeadingContent: {
    padding: '5px 0px',
  },
  descriptionContent: {
    padding: '10px 0px',
  },
  nextButton: {
    background: 'linear-gradient(180deg, #4DC3E3 0%, #1EA0C4 100%) !important',
    color: '#FFFFFF !important',
    fontWeight: '600 !important',
    fontSize: '14px !important',
    fontFamily: 'Roboto !important',
    borderRadius: '5px !important',
  },
  closeButton: {
    top: '0',
    right: '0',
    textAlign: 'right',
    padding: '10px',
    display: 'flex',
    placeSelf: 'flex-end',
  },
})
